import React from 'react';
import ReactDOM from 'react-dom';
import { GatewayDest, GatewayProvider } from 'react-gateway';
import './index.css';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {grey400, grey500} from 'material-ui/styles/colors';
// import AppBar from 'material-ui/AppBar';
import CollectionEditor from './components/CollectionEditor/CollectionEditor';
import CollectionsManagement from './components/Collections/CollectionsManagement';
import Login from './components/Auth/Login';
import ReviewCollection from './components/Tasks/Review/ReviewCollection';
import ViewCollection from './components/Tasks/View/ViewCollection';
import ReviseCollection from './components/Tasks/Revise/ReviseCollection';
import TasksManagement from './components/Tasks/TasksManagement/TasksManagement';
import MarkingManagement from './components/Marking/MarkingManagement';
import MarkingAttempt from './components/Marking/MarkingAttempt';
import ViewSubmission from './components/Marking/ViewSubmission';
import ExamsManagement from './components/Exam/ExamsManagement';
import ExamEditor from './components/ExamEditor/ExamEditor';
import Settings from './components/Settings/settings';

import Students from './components/Students/students'; //for the students UI (added by David)
import ViewStudent from './components/Students/ViewStudent'; //to look at a student's particulars (added by David)
import LinkStudent from './components/Students/LinkStudent';
import StudentEditor from './components/StudentEditor/StudentEditor';
import StudentClasses from './components/StudentClasses/StudentClasses'; //for the classes UI (added by David)
import StudentClassEditor from './components/StudentClassEditor/StudentClassEditor';
import ViewStudentClass from './components/StudentClasses/ViewStudentClass'; //to look at the students in a class
import ViewStudentActivity from './components/StudentAnalytics/ViewStudentActivity'; //to look at a student's activity history
import ViewStudentActivityAttempt from './components/StudentAnalytics/ViewStudentActivityAttempt'; //to look at a student's activity/practice attempt
import ViewStudentConceptMap from './components/StudentAnalytics/ViewStudentConceptMap'; //to look at a student's concept map
import ViewStudentMistakesBank from './components/StudentAnalytics/ViewStudentMistakesBank'; //to look at a student's mistakes bank
import ViewStudentMistakesForDay from './components/StudentAnalytics/ViewStudentMistakesForDay'; //to look at a student's mistakes for a particular day
import ViewStudentStatistics from './components/StudentAnalytics/ViewStudentStatistics'; //to look at a student's statistics
import ViewAllSchools from './components/Schools/ViewAllSchools';
import ViewSchool from './components/Schools/ViewSchool'
import SchoolEditor from './components/SchoolEditor/SchoolEditor';
import Teachers from './components/Teachers/teachers'; //for the teachers UI (added by David)
import TeacherEditor from './components/TeacherEditor/TeacherEditor';
import ViewTeacher from './components/Teachers/ViewTeacher';

require('react-web-vector-icons/fonts');

import { Router, Route,Redirect, Link, browserHistory } from 'react-router';
import stacked_icon from './images/stacked_files.png';
import { requestPermission, uploadFileS3 } from './resources/media'
var injectTapEventPlugin = require("react-tap-event-plugin");
var auth = require('./resources/auth');
var $ = require('jquery');
import runtimeEnv from '@mars/heroku-js-runtime-env';

injectTapEventPlugin();
window.CKEDITOR.config.imageUploaderCustomUploadHandler = uploadFileS3;
if (typeof Object.assign !== 'function') {
  Object.assign = function (target, varArgs) { // .length of function is 2
    if (target == null) { // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource !== null) { // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}

var muiTheme = getMuiTheme({
  palette: {
    primary1Color: "#4DC3CA",
    primary2Color: "#3b9fa4",
    primary3Color: grey400,
    accent1Color: "#E47923",
    //accent2Color: "#C56619",
    accent3Color: grey500,
  },
  appBar: {
    height: 50,
  },
});

var editorPath = /\/collection\/[a-z0-9]/;

var App = React.createClass({

  logout: function() {
    if (editorPath.test(this.props.location.pathname)) {
      var r = confirm('Are you sure you want to logout? Any changes may not be saved');
      if (!r) return;
    }
    $("body").addClass("heavy-load");
    auth.logout(function(err, res) {
      $("body").removeClass("heavy-load");
      if (err) return alert("Please try again");
      browserHistory.push('/login');
    })
  },

  safeNavigateLink: function(route) {
    if (!route) return;
    if (editorPath.test(this.props.location.pathname)) {
      var r = confirm('Are you sure you want to logout? Any changes may not be saved');
      if (!r) return;
    }
    browserHistory.push(route);
  },

  componentWillMount: function() {

  },

  componentDidMount: function() {

    browserHistory.push('/students');
  },

  render: function() {
    // Load the env object.
    // const env = runtimeEnv();
    // console.log("ENV", env.REACT_APP_API_DOMAIN);
    // console.log('process.env', process.env.NODE_ENV, process.env.REACT_APP_API_DOMAIN);
    var currentUser = auth.getCurrentUser(),
        isAdmin = currentUser && currentUser.status && currentUser.status.indexOf('admin') >= 0,
        isReviewer = currentUser && currentUser.status && currentUser.status.indexOf('reviewer') >= 0,
        isTeacher = currentUser && currentUser.status && currentUser.status.indexOf('teacher') >= 0;

    //get current user's email address
    var currentUserEmail = currentUser.email;
    var isAdminRoot = false;

    //check to see if is system/root admin
    if (isAdmin && currentUserEmail=="admin1@inspicorp.com") { isAdminRoot = true; }


    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <GatewayProvider>
          <div className="app">
            <div>
              <nav className="app-nav">
                <div className="nav-header">
                  <Link to={"/"}>A-SLS</Link>
                </div>
                <div className="nav-right">
                  <span style={{color: "white"}} className="padding-right-10">
                    <small>{"(You logged in as " + (isAdmin ? "Admin" : (isReviewer ? "Reviewer" : "Setter")) + ")"}</small>
                    </span>
                  <a href="#" onClick={this.logout}>Sign out</a>
                </div>
              </nav>
              <div className="nav-offset"></div>
              <aside className="app-aside">
                <ul>
                  { /*for Students Menu (added by David) */
                    (isTeacher || isAdmin) &&
                    <li>
                      <a onClick={this.safeNavigateLink.bind(this, "/students")}>
                        <i className="fa fa-file-o" style={{"paddingRight": "15.3px", "fontSize": "16px"}}></i>
                        <span>Students</span>
                      </a>
                    </li>
                  }
                  {
                    (isAdminRoot) &&
                    <li>
                      <a onClick={this.safeNavigateLink.bind(this, "/teachers")}>
                        <i className="fa fa-file-o" style={{"paddingRight": "15.3px", "fontSize": "16px"}}></i>
                        <span>Teachers</span>
                      </a>
                    </li>
                  }
                  { /*for Classes Menu (added by David) */
                    (isTeacher || isAdmin) &&
                    <li>
                      <a onClick={this.safeNavigateLink.bind(this, "/classes")}>
                        <i className="fa fa-file-o" style={{"paddingRight": "15.3px", "fontSize": "16px"}}></i>
                        <span>Classes</span>
                      </a>
                    </li>
                  }
                  {
                    isAdmin &&
                      <li>
                        <a onClick={this.safeNavigateLink.bind(this, "/schools")}>
                          <i className="fa fa-file-o" style={{"paddingRight": "15.3px", "fontSize": "16px"}}></i>
                          <span>Schools</span>
                        </a>
                      </li>
                  }
                  {
                    (isTeacher || isAdmin) &&
                      <li>
                        <a onClick={this.safeNavigateLink.bind(this, "/collections")}>
                          <i className="fa fa-file-o" style={{"paddingRight": "15.3px", "fontSize": "16px"}}></i>
                          <span>Collections</span>
                        </a>
                      </li>
                  }
                  {
                    isAdmin && 
                    <li>
                      <a onClick={this.safeNavigateLink.bind(this, "/mock-exams")}>
                        <img src={stacked_icon} alt="mock exam icons" height="22px" width="19px" style={{"marginRight": "10px"}}></img>
                        <span>Mock Exam</span>
                      </a>
                    </li>
                  }
                  {
                    (isReviewer || isAdmin) &&
                    <li>
                      <a onClick={this.safeNavigateLink.bind(this, "/review-tasks")}>
                        <i className="fa fa-list" style={{"paddingRight": "10px", "fontSize": "16px"}}></i>
                        <span>Review Tasks</span>
                      </a>
                    </li>
                  }
                  {
                    (isTeacher || isAdmin) &&
                    <div>
                      <li>
                        <a href="#" style={{"pointerEvents": "none"}}>
                          <i className="fa fa-bookmark-o" style={{"paddingRight": "15.3px", "fontSize": "16px"}}></i>
                          <span>Submissions</span>
                        </a>
                      </li>
                      <ul style={{"listStyleType": "none", "borderBottom": "none", "borderTop": "none", "marginLeft": "30px"}}>
                        <li style={{"borderTop": "none"}}>
                          <a onClick={this.safeNavigateLink.bind(this, "/submissions/practice")}>
                            <i className="fa fa-ellipsis-v" style={{"paddingRight": "25px", "fontSize": "16px"}}></i>
                            <span>Long structure</span>
                          </a>
                        </li>
                        <li style={{"borderBottom": "none"}}>
                          <a onClick={this.safeNavigateLink.bind(this, "/submissions/exam")}>
                            <i className="fa fa-graduation-cap" style={{"paddingRight": "10px", "fontSize": "16px"}}></i>
                            <span>Exam</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  }
                  <li>
                    <Link to="/settings">
                      <i className="fa fa-cog" style={{"paddingRight": "10px", "fontSize": "16px"}}></i>
                      <span>Settings</span>
                    </Link>
                  </li>
                </ul>
              </aside>
              <main className="app-container">
                {this.props.children}
              </main>
            </div>
            <GatewayDest name="confirm-modal" className="modal-container"/>
            <GatewayDest name="notification-modal" className="modal-container"/>
            <GatewayDest name="snack-notification"/>
          </div>
        </GatewayProvider>
      </MuiThemeProvider>
    )
  }
})

var requireAuth = function(nextState, replace, callback) {
  auth.hasLoggedIn(function(err, result) {
    if (err) {
      replace({
        pathname: '/login',
        state: { nextPathname: nextState.location.pathname }
      });
    }
    return callback(); 
  })
}

browserHistory.listen(function(ev) {
  // console.log('listen', ev);
});

ReactDOM.render((
  <Router history={browserHistory}>
    <Route path="/" component={App} onEnter={requireAuth}>
    
      <Route path="collections" component={CollectionsManagement} onEnter={requireAuth}/>
      <Route path="mock-exams" component={ExamsManagement} onEnter={requireAuth}/>
      <Route path="mock-exam/:examId" component={ExamEditor} onEnter={requireAuth}/>
      <Route path="collection/:collectionId" component={CollectionEditor} onEnter={requireAuth} />
      <Route path="review/:id" component={ReviewCollection} onEnter={requireAuth} />
      <Route path="view/:collectionId" component={ViewCollection} onEnter={requireAuth} />
      <Route path="revise/:collectionId" component={ReviseCollection} onEnter={requireAuth} />
      <Route path="review-tasks" component={TasksManagement} onEnter={requireAuth}/>
      <Route path="submissions/:type" component={MarkingManagement} onEnter={requireAuth} />
      <Route path="marking/:attemptId" component={MarkingAttempt} onEnter={requireAuth} />
      <Route path="view-submission/:attemptId" component={ViewSubmission} onEnter={requireAuth} />
      <Route path="teachers" component={Teachers} onEnter={requireAuth} />
      <Route path="teacher/new" component={TeacherEditor} onEnter={requireAuth} />
      <Route path="teacher/:teacherId" component={ViewTeacher} onEnter={requireAuth} />
      <Route path="teacher/edit/:teacherId" component={TeacherEditor} onEnter={requireAuth} />
      <Route path="students" component={Students} onEnter={requireAuth} />
      <Route path="student/new" component={StudentEditor} onEnter={requireAuth} />
      <Route path="student/link" component={LinkStudent} onEnter={requireAuth} />
      <Route path="student/:studentId" component={ViewStudent} onEnter={requireAuth} />
      <Route path="student/edit/:studentId" component={StudentEditor} onEnter={requireAuth} />
      <Route path="student/activity/:studentId" component={ViewStudentActivity} onEnter={requireAuth} />
      <Route path="student/activity/:studentId/practices/:conceptId/:timeValue" component={ViewStudentActivityAttempt} onEnter={requireAuth} />
      <Route path="student/conceptmap/:studentId" component={ViewStudentConceptMap} onEnter={requireAuth} />
      <Route path="student/mistakesbank/:studentId" component={ViewStudentMistakesBank} onEnter={requireAuth} />
      <Route path="student/mistakesbank/:studentId/mistakes/:conceptId/:timeValue" component={ViewStudentMistakesForDay} onEnter={requireAuth} />
      <Route path="student/statistics/:studentId" component={ViewStudentStatistics} onEnter={requireAuth} />
      <Route path="classes" component={StudentClasses} onEnter={requireAuth} />
      <Route path="class/new" component={StudentClassEditor} onEnter={requireAuth} />
      <Route path="class/edit/:studentClassId" component={StudentClassEditor} onEnter={requireAuth} />
      <Route path="class/:studentClassId" component={ViewStudentClass} onEnter={requireAuth} />
      <Route path="schools" component={ViewAllSchools} onEnter={requireAuth} />
      <Route path="schools/new" component={SchoolEditor} onEnter={requireAuth} />
      <Route path="school/edit/:schoolId" component={SchoolEditor} onEnter={requireAuth} />
      <Route path="school/:schoolId" component={ViewSchool} onEnter={requireAuth} />
      
      <Route path="settings" component={Settings} onEnter={requireAuth} />
    </Route>
    <Route path="/login" component={Login} />
  </Router>
), document.getElementById('root'))



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/